import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { ChevronLeft, ChevronRight, Mail } from 'lucide-react'
import api from 'api/api'
import { MESSAGE_REQUEST_COUNT_QUERY_KEY } from 'lib/directMessageRequestFeeds'
import styles from './message-requests-entry.module.scss'

// Refreshed when a request is answered (DirectMessageRequestBar).
export { MESSAGE_REQUEST_COUNT_QUERY_KEY } from 'lib/directMessageRequestFeeds'

// Message requests live inside Direct Messages: under the Private tabs, Direct
// Messages shows a way in while requests wait (with their count), and the
// requests list shows the way back.
export default function MessageRequestsEntry({
    viewingRequests,
    onToggle,
}: {
    viewingRequests: boolean
    onToggle: (showRequests: boolean) => void
}) {
    const { data: count = 0 } = useQuery({
        queryKey: MESSAGE_REQUEST_COUNT_QUERY_KEY,
        queryFn: () => api.getMessageRequestCount(),
        staleTime: 30_000,
    })

    if (viewingRequests) {
        return (
            <button
                type="button"
                className={styles.row}
                onClick={() => onToggle(false)}
                data-testid="message-requests-back"
            >
                <ChevronLeft className={styles.icon} aria-hidden />
                <span className={styles.title}>Message requests</span>
                <span className={styles.caption}>From people you don’t follow</span>
            </button>
        )
    }

    if (!count) return null
    return (
        <button
            type="button"
            className={styles.row}
            onClick={() => onToggle(true)}
            data-testid="message-requests-entry"
        >
            <Mail className={styles.icon} aria-hidden />
            <span className={styles.title}>Message requests</span>
            <span className={styles.count}>{count}</span>
            <ChevronRight className={styles.chevron} aria-hidden />
        </button>
    )
}
